import { Component, OnInit } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { Item } from '@app/core/components/listbox/listbox.component';
import { StateService } from '@app/core/services/state.service';
import { P2ReportDefinitionService } from '@app/services/p2-report-definition.service';
import { VtLinkService, VtLinkSetting, VtLinkType } from '@app/services/vt-link.service';

@Component({ selector: 'tt-vt-link', templateUrl: './vt-link.component.html', styleUrls: ['./vt-link.component.css'], standalone: false })
export class VtLinkComponent implements OnInit {
    public page?: VtLinkSetting;
    public grid?: GridOptions;
    public selectListLinkTypes: VtLinkType[] = [];
    public selectListWebPages: Item[] = [];

    constructor(private service: VtLinkService, private pages: P2ReportDefinitionService, private state: StateService) {}

    public get isNew(): boolean { return this.page?.vtlink_keyno === '0'; }

    public async onArgTypeChanged(value: string): Promise<void> {
        if (!this.page || value === this.page.argtype) return;
        this.page.argtype = value;
        if (value) this.grid?.gridfunc?.read();
    }

    private configureGrid(): void {
        if (!this.page) return;
        this.grid = new Grid()
            .setRememberId('w_vtlink_multi_grid')
            .setLoadDataFunction({ method: 3795, parameters: () => this.page! })
            .setKendoConfig({ height: '100%', sortable: true, aggregate: true, pager: false, pageable: false, selectable: false, filterable: false });
    }

    public async ngOnInit(): Promise<void> {
        const params = this.state.getStateParams();
        const [setting, types, webPages] = await Promise.all([
            this.service.getSetting({ vt_keyno: params['vt_keyno'] ?? '', vtlink_keyno: params['vtlink_keyno'] ?? '' }),
            this.service.listLinkTypes(), this.pages.listWebPages(),
        ]);
        this.page = setting[0];
        this.selectListLinkTypes = types;
        this.selectListWebPages = webPages;
        this.configureGrid();
    }
}
